import { NavigationNoticiasItems } from './sections/NavigationNoticiasItems';
import { NavigationFantasyRelevoItems } from './sections/NavigationFantasyRelevoItems';
import { NavigationFantasyBiwengerItems } from './sections/NavigationFantasyBiwengerItems';
import { NavigationPredictingManagerItems } from './sections/NavigationPredictingManagerItems';
import { NavigationJugadoresItems } from './sections/NavigationJugadoresItems';
import { NavigationUsuarioItems } from './sections/NavigationUsuarioItems';
import { NavigationAdminItems } from './sections/NavigationAdminItems';
import { NavigationEditorItems } from './sections/NavigationEditorItems';
import { SUBSCRIPTION_TYPE } from '@/constants/subscription-type';
import ArticleIcon from '@mui/icons-material/Article';
import AlineacionesProbablesIcon from './icons/AlineacionesProbablesIcon';
import Groups2Icon from '@mui/icons-material/Groups2';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import BiwengerIcon from '../icons/biwenger-icon';
import PredictingManagerIcon from '../icons/predicting-manager-icon';
import { NavigationLaLigaItems } from './sections/NavigationLaLigaItems';
import FantasyLaLigaIcon from '../icons/fantasy-la-liga-icon';
import FantasyMarcaIcon from '../icons/FantasyMarcaIcon';
import { useTheme } from '@mui/material';
import { Rutas } from '@/constants/rutas';
import { NavigationFantasyMarcaItems } from './sections/NavigationFantasyMarcaItems';
import { NavigationFantasyKaosItems } from './sections/NavigationFantasyKaosItems';
import { NavigationMisterFantasyItems } from './sections/NavigationMisterFantasyItems';
import MisterFantasyIcon from '../icons/MisterFantasyIcon';
import { NavigationColaboradoresItems } from './sections/NavigationColaboradoresItems';
import { NavigationPrediccionesFantasyItems } from './sections/NavigationPrediccionesFantasyItems';
import PrediccionesFantasyIcon from '../icons/predicciones-fantasy-icon';
import { NavigationRuletaFantasyItems } from './sections/NavigationRuletaFantasyItems';

const NavigationItems = (user, isDesktop, size = 20, takeAll = false) => {
    const isEditor = user?.role?.toLowerCase() === 'editor';
    const isAdmin = user?.role?.toLowerCase() === 'admin';
    const theme = useTheme();
    const styles = {
        fontSize: `${size}px`,
    };

    let items = [
        {
            title: 'Inicio',
            subMenu: NavigationNoticiasItems,
            icon: <ArticleIcon sx={styles} />,
        },
        {
            title: 'Fantasy',
            subMenu: NavigationFantasyRelevoItems,
            icon: <AlineacionesProbablesIcon width={size} height={size} />,
        },
        {
            title: 'Marca',
            subMenu: NavigationFantasyMarcaItems,
            icon: <FantasyMarcaIcon width={size} height={size} />,
        },
        {
            title: 'Mister',
            subMenu: NavigationMisterFantasyItems,
            icon: <MisterFantasyIcon width={size} height={size} />,
        },
        {
            title: 'Biwenger',
            subMenu: NavigationFantasyBiwengerItems,
            icon: <BiwengerIcon width={size} height={size} />,
        },
        {
            title: 'Predicting',
            subMenu: NavigationPredictingManagerItems,
            hideInMobile: true,
            icon: <PredictingManagerIcon width={size} height={size} />,
            className: 'hidden-1500',
        },
        {
            title: 'Predicciones Fantasy',
            subMenu: NavigationPrediccionesFantasyItems,
            icon: <PrediccionesFantasyIcon width={size} height={size} />,
            hideInDesktop: true,
        },
        {
            title: 'Jugadores',
            subMenu: NavigationJugadoresItems,
            icon: <Groups2Icon sx={styles} />,
        },
        {
            title: 'Usuario',
            subMenu: NavigationUsuarioItems,
            icon: <PeopleOutlineIcon sx={styles} />,
        },
        {
            title: 'La Liga',
            subMenu: NavigationLaLigaItems,
            icon: <FantasyLaLigaIcon iconWidth={size} iconHeight={size} color={theme.palette.text.primary} />,
            hideInMobile: true,
            className: 'hidden-1400',
        },
        {
            title: 'Admin',
            subMenu: NavigationAdminItems,
            hideInMobile: true,
            hideInDesktop: true,
            isAdmin: true,
        },
        {
            title: 'Editores',
            subMenu: NavigationEditorItems,
            hideInMobile: true,
            hideInDesktop: true,
            isEditor: true,
        },
        {
            title: 'Fantasy Kaos',
            subMenu: NavigationFantasyKaosItems,
            hideInMobile: true,
            hideInDesktop: true,
        },
        {
            title: 'Colaboradores',
            subMenu: NavigationColaboradoresItems,
            hideInMobile: true,
            hideInDesktop: true,
        },
        {
            title: 'Ruleta Fantasy',
            subMenu: NavigationRuletaFantasyItems,
            hideInMobile: true,
            hideInDesktop: true,
        },
        {
            title: 'Instala la app',
            hideInMobile: false,
            hideInDesktop: true,
            path: Rutas.INSTALL_APP,
        },
        {
            title: 'Buzón del ciudadano',
            hideInMobile: false,
            hideInDesktop: true,
            path: Rutas.BUZON_CIUDADANO,
        },
    ];

    // Lógica para filtrar items de admin y editores según el rol del usuario
    if (!user?.logged) {
        // Si no está logueado, no mostrar nada de admin ni editores
        items = items.filter((link) => !link.isAdmin && !link.isEditor);
    } else if (!isAdmin && !isEditor) {
        // Si no es admin ni editor, no mostrar nada de admin ni editores
        items = items.filter((link) => !link.isAdmin && !link.isEditor);
    } else if (isEditor && !isAdmin) {
        // Si es editor pero no admin, no mostrar items de admin
        items = items.filter((link) => !link.isAdmin);
    }
    // Si es admin, tiene acceso a todo (se muestran ambos menús: Admin y Editores)

    if (user?.subscriptionType !== SUBSCRIPTION_TYPE.PREMIUM) {
        items = items.filter((link) => !link.isPremium);
    }

    if (takeAll) {
        return items;
    }

    if (!isDesktop) {
        items = items.filter((link) => !link.hideInMobile);
    } else if (isDesktop) {
        items = items.filter((link) => !link.hideInDesktop);
    }

    return items;
};

export const NavigationItemsFixed = () => {
    const items = [
        NavigationUsuarioItems.find((item) => item.id === 'plantillas'),
        NavigationLaLigaItems.find((item) => item.id === 'calendario'),
        NavigationFantasyRelevoItems.find((item) => item.id === 'fantasy-la-liga-rachas'),
        NavigationFantasyMarcaItems.find((item) => item.id === 'fantasy-marca-estadisticas'),
        NavigationFantasyRelevoItems.find((item) => item.id === 'mercado'),
        NavigationLaLigaItems.find((item) => item.id === 'alineaciones-probables'),
    ];

    return items;
};

export default NavigationItems;
